export const    POST_VERSION = 'POST_VERSION';
export const    POST_VERSION_SUCCESS = 'POST_VERSION_SUCCESS';
export const    POST_VERSION_ERROR = 'POST_VERSION_ERROR';

export const    PUT_VERSION = 'PUT_VERSION';
export const    PUT_VERSION_SUCCESS = 'PUT_VERSION_SUCCESS';
export const    PUT_VERSION_ERROR = 'PUT_VERSION_ERROR';

export const    PUT_COMMUNITY_VERSION = 'PUT_COMMUNITY_VERSION';
export const    PUT_COMMUNITY_VERSION_SUCCESS = 'PUT_COMMUNITY_VERSION_SUCCESS';
export const    PUT_COMMUNITY_VERSION_ERROR = 'PUT_COMMUNITY_VERSION_ERROR';

export const    GET_ALL_VERSIONS = 'GET_ALL_VERSIONS';
export const    GET_ALL_VERSIONS_SUCCESS = 'GET_ALL_VERSIONS_SUCCESS';
export const    GET_ALL_VERSIONS_ERROR = 'GET_ALL_VERSIONS_ERROR';

export const    GET_ALL_VERSIONS_BY_COMMUNITY = 'GET_ALL_VERSIONS_BY_COMMUNITY';
export const    GET_ALL_VERSIONS_BY_COMMUNITY_SUCCESS = 'GET_ALL_VERSIONS_BY_COMMUNITY_SUCCESS';
export const    GET_ALL_VERSIONS_BY_COMMUNITY_ERROR = 'GET_ALL_VERSIONS_BY_COMMUNITY_ERROR';

export const    CLEAR_VERSIONS = 'CLEAR_VERSIONS';

export const LOCALPATH =  "http://localhost:3000/api/v1/";
export const STAGINPATH ="http://dev.api.engage360.evacompute.com:3000/api/v1/";
export const PRODUCTIONPATH ="https://api.engage360.evacompute.com:443/api/v1/";
